import { makeStateKey } from "@angular/core";

import { ABTestTransferState } from "./ab-testing.type";

export const AB_TEST_LOCAL_STORAGE_KEY = "ab_testing";
export const AB_TEST_LOCAL_STORAGE_SEPARATOR = "_";

/** Each A/B Test query parameters are prefixed with this key */
export const PREFIX_A_B_TEST_KEY = "ab_";

/** Query parameter added by the CF Worker to indicate which BCK API is targeted by an A/B test */
export const QUERY_PARAMETER_ROUTES_FOR_AB_TEST = "api_ab_routes";

export const A_TEST_STATE_KEY = makeStateKey<ABTestTransferState>("ab");
